import React, { useEffect, useState } from "react";
import { Row, Col, Descriptions, Form, Input, Button, Modal, Table, notification, Divider } from "antd";
import { DeleteOutlined, ExclamationCircleOutlined, PlusOutlined, CloseOutlined, WhatsAppOutlined } from "@ant-design/icons";
import moment, { now } from 'moment';

import api from "../../../services/api";
import { useStateValue } from '../../../state';
import { listagemActions } from "../../../actions";
import { FormatNumber, FormatFone } from "../../../ValueObjects";
import { formatarCpf, isObjetoDiffVazio } from "../../../services/funcoes";
import ModalImagemQr from "../modalImagemQr";
import InputPhone from "../../inputPhone";

export default function ModalEnvioPedidoWhats({ exibirPedidoWhats, fecharPedidoWhats }) {

    const [{ manutencao }, dispatch] = useStateValue();
    const [dadosPedido, setDadosPedido] = useState({});
    const [listaWhats, setListaWhats] = useState([]);
    const [form] = Form.useForm();
    const [base64Image, setBase64Image] = useState('');
    const [conectado, setConectado] = useState(false);
    const [exibirQr, setExibirQR] = useState(false);
    const [temporizador, setTemporizador] = useState(60);
    const [carregando, setCarregando] = useState(false);

    useEffect(() => {
        if (!!manutencao.dados && isObjetoDiffVazio(manutencao.dados)) {
            retornaDadosCliente(manutencao.dados);
            setDadosPedido(manutencao.dados);
            conectar();
        }
    }, [manutencao.dados]);

    useEffect(() =>
        dispatch({ type: listagemActions.CHANGE, data: { ordem: '+dest' } }), []);

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                setListaWhats(null);
                form.resetFields();
                fecharPedidoWhats();
            }
        });
    };

    const onCloseModalQr = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                setExibirQR(false);
                setTemporizador(temporizador);

            }
        });
    };

    async function enviarWhats() {
        let dados = {};
        let numero = [];
        listaWhats.forEach((Whats) => {
            numero.push(Whats.dest);
        })
        dados.orc_id = dadosPedido.ped_id;
        dados.numeroDestinatarios = numero;
        let whats = {
            Id: dadosPedido.ped_id,
            numerosReceptor: numero,
            documento: null,
            //extensao: 'pdf', //podera ser utilizado no futuro para enviar o arquivo em formatos alem de pdf
            mensagem: form.getFieldValue().mensagem
        };
        /// numero da empresa deve ser um numero com codigo de area mais numero de telefone com 8 digitos
        if (conectado === true && (!!!numero || numero.length > 0)) {
            enviarDados(whats);
        }
        else if (!numero || numero.length === 0 && conectado === false) {
            notification.Alert({ description: 'Adicione um ou mais numeros de remetente!', message: 'Aviso' });
            return;
        }
        else if (conectado === false && !!!numero || numero.length > 0) {
            gerarQRCode(whats);
        }
    }

    async function gerarQRCode(whats) {
        let base64 = (await api.get(`WhatsApp/GeraQrCodeWhats`)).data; // Pode passar qualquer string aqui
        setExibirQR(true);
        setBase64Image(base64);  // Atualiza o estado com o QR Code
        verificarConexao(whats);
    }

    async function conectar() {
        let conectar = (await api.get('WhatsApp/WhatsConectado')).data;
        setConectado(conectar);
        return conectar;
    }

    async function verificarConexao(whats) {
        const timeout = Date.now() + (temporizador * 1000); // Define o tempo limite em segundos
        while (Date.now() < timeout) {
            let status = await conectar();
            if (status === true) {
                setExibirQR(false);
                console.log("Conectado!");
                enviarDados(whats);
                notification.success({ description: 'Conectado!', message: 'Aviso' });
                return;
            }
            await new Promise((resolve) => setTimeout(resolve, 4500)); // Aguarda 4,5s antes de tentar novamente
        }
        gerarQRCode(); // Chama a função para gerar um novo QR Code
    }


    async function enviarDados(whats) {
        setCarregando(true);
        var url = "Pedido/EnviarWhats";
        api.post(url, whats).then(
            (res) => {
                notification.success({ description: 'Pedido enviado com sucesso!', message: 'Aviso' });
            }
        ).catch(
            (erro) => {
                setCarregando(false);
                console.log(erro);
            }
        ).finally(
            () => {
                setCarregando(false);
                fecharPedidoWhats()
            }
        );
        form.resetFields();
    }

    async function retornaDadosCliente(dados) {
        if (!!dados) {
            let lista = [];
            let clienteTelefone = (await api.get(`PessoaTelefone/ListaTelefone?IdPessoa=` + dados.pes_id)).data;
            if (!!clienteTelefone) {
                let telefoneWhats = clienteTelefone.filter(telefone => telefone.psc_whatsapp === true);
                // Adiciona todos os telefones filtrados à lista
                telefoneWhats.forEach((telefone, index) => {
                    if (telefone.psc_numero) { // Verifica se o número não é null ou undefined
                        lista.push({ id: index, dest: telefone.psc_numero });
                    }
                });
            }
            setListaWhats(lista);
        }
    }

    function adicionarWhats() {
        let numero = form.getFieldValue().numeroWhats;
        if (!!numero) {
            let lista = [...listaWhats];
            lista.push({ id: lista.length, dest: numero });
            setListaWhats(lista);
            form.setFieldsValue({ numeroWhats: null });
        }
    };

    function excluirWhats(record) {
        let listaE = [...listaWhats];
        let WhatsLista = listaE.filter((lista) => (lista.id !== record.id));
        setListaWhats(WhatsLista);
    };

    return (
        <Modal centered
            title={`Enviar Pedido por WhatsApp`}
            open={exibirPedidoWhats}
            confirmLoading={carregando}
            onCancel={onCloseModal}
            onOk={enviarWhats}
            okText={
                <>
                    <WhatsAppOutlined /> Enviar WhatsApp
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
        >
            <div>
                <div>
                    <Descriptions size="small">
                        <Descriptions.Item label="Nº Pedido">
                            <b>{dadosPedido.ped_numero}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Emissão">
                            <b>{!!dadosPedido.ped_datainclusao ? moment(dadosPedido.ped_datainclusao).format('DD/MM/YYYY') : null}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Valor (R$)">
                            <b>{!!dadosPedido.ped_valortotal ? FormatNumber(dadosPedido.ped_valortotal, true) : null}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Destinatário">
                            <b>{dadosPedido.pes_nome}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="CPF/CNPJ">
                            <b>{!!dadosPedido.pej_cnpj ? formatarCpf(dadosPedido.pej_cnpj) : (!!dadosPedido.pef_cpf ? formatarCpf(dadosPedido.pef_cpf) : '')}</b>
                        </Descriptions.Item>
                    </Descriptions>
                </div>
                <Form layout="vertical" form={form} >
                    <Col >
                        <Form.Item label="Mensagem" name="mensagem">
                            <Input placeholder="Mensagem de texto que sera enviado" />
                        </Form.Item>
                    </Col>
                </Form>
                <Form layout="vertical" form={form} className="m-t-8">
                    <Row gutter={[8, 0]}>
                        <Col xs={24} sm={16} md={18} lg={18} xl={18}>
                            <InputPhone label="N° de Telefone do Destinatário" name="numeroWhats" placeholder="N° de Telefone do Destinatário aqui" />
                        </Col>
                        <Col xs={24} sm={8} md={6} lg={6} xl={6} className="t-mob-573">
                            <Button type="primary" icon={<PlusOutlined />} onClick={() => adicionarWhats()} block>Adicionar</Button>
                        </Col>
                    </Row>
                </Form>
                <div className="tabela">
                    <Table columns={[
                        {
                            title: 'N° Telefone Destinatário',
                            render: ({ dest }) => (
                                <div>
                                    <b>{FormatFone(dest)}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Ações',
                            dataIndex: '',
                            key: 'x',
                            align: 'center',
                            width: 65,
                            render: (record) => (
                                <div>
                                    <Row align="middle" justify="center" gutter={[5, 0]}>
                                        <Col>
                                            <Button onClick={() => { excluirWhats(record) }} icon={<DeleteOutlined />} />
                                        </Col>
                                    </Row>
                                </div>
                            ),
                        },
                    ]} dataSource={listaWhats} locale={{
                        emptyText: (
                            <Row>
                                <Col span={24}>
                                    <Divider orientation="center">
                                        <ExclamationCircleOutlined /> Nenhum Registro Encontrado
                                    </Divider>
                                </Col>
                            </Row>
                        )
                    }} />
                </div>
            </div>
            <Modal centered
                title={`Enviar por WhatsApp`}
                open={exibirQr}
                onCancel={onCloseModalQr}
                footer={[
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button key="cancel" onClick={() => onCloseModalQr()}>
                            Cancelar
                        </Button>
                    </div>
                ]}
                width={305} // Define a largura do modal (padrão é 520px)
                bodyStyle={{ height: "320px" }} // Define a altura do corpo do modal
            >
                <ModalImagemQr centered isOpen={exibirQr} base64Image={base64Image} tempo={temporizador} />
            </Modal>
        </Modal>
    );
}